export enum EventType {
	SHOPPER_EMAIL_SAVED = 'shopperEmailSaved',
	GAME_PLAYED = 'gamePlayed',
	PAGE_VIEWED = 'pageViewed',
	CART_UPDATED = 'cartUpdated',
	CART_VALIDATED = 'cartValidated',
	CART_CANCELED = 'cartCanceled',
	BANNER_CLICKED = 'bannerClicked',
	BANNER_VIEWED = 'bannerViewed',
	OPTIN_ACCEPTED = 'optinAccepted',
	OPTIN_REFUSED = 'optinRefused',
	REWARD_INFO_FILLED = 'rewardInfoFilled',
	REWARD_DONE = 'rewardDone',
	REWARD_BLOCKED = 'rewardBlocked',
	REWARD_SENT = 'rewardSent',
	EMAIL_STATUS_UPDATED = 'emailStatusUpdated',
}
